import React from 'react';
import { useTheme } from 'react-jss';
import learn from "../../../asset/svg/Learn.svg"
import { convertSlugToUrl } from '../../../resources/utilities';
import LogoComponent from './LogoComponent';
import Menu from './MenuComponent';
import MenuItem from './MenuItemComponent';
import { useLocation, useNavigate } from "react-router-dom";
import home from "../../../asset/svg/Home.svg";
import feed from "../../../asset/svg/Feed.svg";
import star from "../../../asset/svg/Star.svg";
import surveys from "../../../asset/svg/Surveys.svg";
import vouchers from "../../../asset/svg/Vouchers.svg";
import selectedStar from "../../../asset/svg/selectedStar.svg";
import selectedHome from "../../../asset/svg/selectedHome.svg";
import selectedVouchers from "../../../asset/svg/selectedVouchers.svg";
import selectedSurveys from "../../../asset/svg/selectedSurveys.svg";
import selectedFeed from "../../../asset/svg/selectedFeed.svg";
import selectedLearn from "../../../asset/svg/selectedLearn.svg"
import { FEED_PATH, HOME_PATH, REWARDS_PATH, LEAVE_PATH, LEADBOARD_HISTORY, LEARN_PATH, PERFORMANCE_PATH, SURVEY_PATH, VOUCHERS_PATH, WEEKLY_CONTEST, CREAT_LEAVE_PATH, SEND_REWARDS_PATH, CONFIRMATION_REWARD_PATH, } from '../../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux'
import { DASHBOARD_CONFIG, } from '../../../sagas/type';
import { getLocalStore, getLocalStoreString } from '../../../utils/Helper';


function SidebarComponent() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { pathname } = useLocation();
    const theme = useTheme();
    const isMobile = window.innerWidth <= 1080;


    function handleClick(slug, parameters = {}) {
        navigate(convertSlugToUrl(slug, parameters))
    }

    const dashboardConfig = getLocalStore('configPermissionData')
    const Enabled = dashboardConfig && dashboardConfig?.enabled;

    const appNav = [
        {
            name: "Home",
            path: HOME_PATH,
            items: [WEEKLY_CONTEST, LEADBOARD_HISTORY],
        },
        // {
        //     // name: "Leave",
        //     path: LEAVE_PATH,
        //     items: [CREAT_LEAVE_PATH],
        // },
        // {
        //     // name: "Rewards",
        //     path: REWARDS_PATH,
        //     items: [SEND_REWARDS_PATH, CONFIRMATION_REWARD_PATH],
        // },
        // {
        //     name: "Learn",
        //     path: LEARN_PATH,
        //     items: [],
        // },
        // {
        //     name: "Feed",
        //     path: FEED_PATH,
        //     items: [],
        // },
        // {
        //     name: "Vouchers",
        //     path: VOUCHERS_PATH,
        //     items: [],
        // },
        // {
        //     name: "Star Performers",
        //     path: PERFORMANCE_PATH,
        //     items: [],
        // },
        // {
        //     name: "Surveys",
        //     path: SURVEY_PATH,
        //     items: [],
        // }
    ]

    const renderIcon = (type) => {
        switch (type) {
            case "Home":
                return home
            case "Learn":
                return learn
            case "Feed":
                return feed
            case "Vouchers":
                return vouchers
            case "Star Performers":
                return star
            case "Surveys":
                return surveys
            // case "Leave":
            //     return leave
        }
    }

    const renderSelectedIcon = (type) => {
        switch (type) {
            case "Home":
                return selectedHome
            case "Learn":
                return selectedLearn
            case "Feed":
                return selectedFeed
            case "Vouchers":
                return selectedVouchers
            case "Star Performers":
                return selectedStar
            case "Surveys":
                return selectedSurveys
            // case "Leave":
            //     return selectedleaves
        }
    }
    return (
        <Menu isMobile={isMobile}>
            <div style={{ paddingTop: 30, paddingBottom: 30 }}>
                <LogoComponent />
            </div>
            {
                appNav.map((nav) => {
                    console.log("nav", nav);
                    const currentNav = pathname === nav.path || nav.items?.includes(pathname)
                    if (!Enabled && nav.name === "Home") {
                        return null
                    }
                    return (
                        <MenuItem
                            id={nav.path}
                            title={nav.name}
                            items={nav.items}
                            image={currentNav ? renderSelectedIcon(nav.name) : renderIcon(nav.name)}
                            onClick={(e) => handleClick(nav.path)}
                            currentNav={currentNav}
                        />)
                })}
            {/* <MenuItem id='logout' title='Logout' icon={IconLogout} onClick={logout} /> */}
        </Menu>
    );
}

export default SidebarComponent;
